export function OutlineSlidersVerticalIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0483 18.9984C14.0483 17.893 13.1522 16.9968 12.0468 16.9968C10.9413 16.9968 10.0452 17.893 10.0452 18.9984C10.0452 20.1039 10.9413 21 12.0468 21C13.1522 21 14.0483 20.1039 14.0483 18.9984Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9988 17.002V3.00041"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M7.00196 6.99841C7.00196 5.89296 6.10582 4.99682 5.00037 4.99682C3.89492 4.99682 2.99878 5.89296 2.99878 6.99841C2.99878 8.10386 3.89492 9 5.00037 9C6.10582 9 7.00196 8.10386 7.00196 6.99841Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00024 21L5.00024 9.00005"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M5.00024 5.00195V3.00036"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M20.9988 12.0004C20.9988 10.8949 20.1026 9.99877 18.9972 9.99877C17.8917 9.99877 16.9956 10.8949 16.9956 12.0004C16.9956 13.1058 17.8917 14.002 18.9972 14.002C20.1026 14.002 20.9988 13.1058 20.9988 12.0004Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9492 9.99805V2.99968"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M18.9492 21V14.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
